import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.scss';

// Register chameleon-web components
import * as chameleon from '@getgo/chameleon-web';
chameleon;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
